import { Route, Routes } from "react-router-dom";
import { ZeitstrahlListPage } from "./zeitstrahl/ZeitstrahlList";
import { ZeitstrahlDetailPage } from "./zeitstrahl/ZeitstrahlDetail";

/**
 * Zeitstrahl = Störungs-Replay als Logikanalysator über alle Geräte.
 * Struktur analog zu {@link TracesPage}: Liste der Störungen → Detail-Replay.
 * Eine „Störung" ist ein Trace, dessen Teilnehmer Geräte (statt Services) sind.
 */
export function ZeitstrahlPage() {
  return (
    <Routes>
      <Route index element={<ZeitstrahlListPage />} />
      <Route path=":incidentId" element={<ZeitstrahlDetailPage />} />
    </Routes>
  );
}
